import React from 'react'
import ReactDOM from 'react-dom'
import { inject, observer } from 'mobx-react'
import CloseIcon from '../../common/icons/CloseIcon.jsx'
import ManageStatusContent from './ManageStatusContent.jsx'
import ManageTagsContent from './ManageTagsContent.jsx'
import ManageFieldsContent from './fields/ManageFieldsContent.jsx'

const MODALS = {
  status: { title: 'Manage status', Content: ManageStatusContent },
  tags: { title: 'Manage tags', Content: ManageTagsContent },
  fields: { title: 'Manage additional fields', Content: ManageFieldsContent }
}

const ManageModal = ({ manageModalStore }) => {
  const { type } = manageModalStore
  const onClose = React.useCallback(() => manageModalStore.close(), [manageModalStore])

  React.useEffect(() => {
    if (!type) return undefined
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return
      if (document.querySelector('.manage-modal__confirm-overlay, .manage-modal__colour-picker')) return
      onClose()
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [type, onClose])

  if (!type) return null
  const { title, Content } = MODALS[type]

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) onClose()
  }

  return ReactDOM.createPortal(
    <div className='manage-modal__overlay' onClick={handleOverlayClick}>
      <section
        className={`manage-modal manage-modal--${type}`}
        role='dialog'
        aria-modal='true'
        aria-labelledby='manage-modal-title'
      >
        <header className='manage-modal__header'>
          <h2 id='manage-modal-title'>{title}</h2>
          <button type='button' className='manage-modal__close' onClick={onClose} aria-label='Close'>
            <CloseIcon />
          </button>
        </header>
        <Content />
      </section>
    </div>,
    document.body
  )
}

export default inject('manageModalStore')(observer(ManageModal))
